import { nodeApi3 } from '../config'
import { createCakeLegacyClient } from './cakeLegacyContract'

// Chamadas da API Node que espelham as rotas Cake ainda usadas pelo front.
// O corpo da resposta deve seguir docs/cake-migration/technical.md.
// O axios devolve esse corpo em response.data.
export default createCakeLegacyClient(nodeApi3)
